
import create from '@/services/catalog/create'

const PayloadTransformer = ({
    originalSupplyId: original_supply,
    name,
    comment,
  }) => ({
  original_supply,
  name,
  comment
})

export default (payload) =>
  create('services/supplies/clone/', PayloadTransformer(payload))


// WEBPACK FOOTER //
// ./src/services/purchase/createSupplyCopy.js